<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="width:40%; padding-left: 15px;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">&nbsp;</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr v-if="initvalue.report.report_date">
                <td><span style="font-size: 11pt; font-weight: bold">Report Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.report.report_date).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr v-if="initvalue.report.start_date">
                <td><span style="font-size: 11pt; font-weight: bold">Start Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.report.start_date).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr v-if="initvalue.report.end_date">
                <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.report.end_date).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ initvalue.report.report_name }}</b></h4></div></td>
        </tr>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
      <table v-if="header2!=null" style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th v-for="(item, index) in header" v-bind:key="index" :style="`width:${item.width}; text-align: ${item.align!=null ? item.align: 'left'}; border-bottom: 1px; border-bottom-style: solid`">{{ item.text }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans) in initvalue.data.filter(x=>x.isSum!=true)"  v-bind:key="trans._id">
            <td v-for="(item, index) in header" v-bind:key="index" :style="`width:${item.width}; text-align: ${item.align!=null ? item.align: 'left'}; padding-bottom: 5px;`">
              {{ item.format!=null ? getFormat(trans[item.value], item.format) : trans[item.value] }}
            </td>
          </tr>
          <tr><td :colspan="header.length" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr v-for="(trans) in initvalue.data.filter(x=>x.isSum==true)"  v-bind:key="trans._id">
            <td v-for="(item, index) in header" v-bind:key="index" :style="`width:${item.width}; text-align: ${item.align!=null ? item.align: 'left'};`">
              {{ item.format!=null ? getFormat(trans[item.value], item.format) : trans[item.value] }}
            </td>
          </tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th v-for="(item, index) in header2" v-bind:key="index" :style="`width:${item.width}; text-align: ${item.align!=null ? item.align: 'left'}; border-bottom: 1px; border-bottom-style: solid`">{{ item.text }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans) in initvalue.data.filter(x=>x.isSum!=true)"  v-bind:key="trans._id">
            <td v-for="(item, index) in header2" v-bind:key="index" :style="`width:${item.width}; text-align: ${item.align!=null ? item.align: 'left'}; padding-bottom: 5px;`">
              {{ item.format!=null ? getFormat(trans[item.value], item.format) : trans[item.value] }}
            </td>
          </tr>
          <tr><td :colspan="header2.length" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr v-for="(trans) in initvalue.data.filter(x=>x.isSum==true)"  v-bind:key="trans._id">
            <td v-for="(item, index) in header2" v-bind:key="index" :style="`width:${item.width}; text-align: ${item.align!=null ? item.align: 'left'};`">
              {{ item.format!=null ? getFormat(trans[item.value], item.format) : trans[item.value] }}
            </td>
          </tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../../util/tools';

export default {
  name: 'PrintReport',
  data() {
    return {
      logo: null,
      initvalue: {},
      data_company: {},
      header: [],
      header2: [],
      header_values: [],
      header_names: [],
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getBillRequest', 'getCompanyDataRequest']),
    getFormat(value, format){
      let result;
      if(format=='decimal') result = value!=null ? (value).toFixed(2) : 0;
      else if(format=='date') result = value!=null ? new Date(value).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '';
      else result = value;
      return result;
    }
  },
  computed: {

  },
  async created() {
    this.initvalue = this.$route.params;
    this.header = this.initvalue.header.filter(x=>x.ignore!==true);
    let object_values = Object.groupBy(this.header, item => { return item.value });
    let object_names = Object.groupBy(this.header, item => { return item.text });
    this.header_values = Object.keys(object_values); 
    this.header_names = Object.keys(object_names);

    if(this.initvalue.header2!=null){
      this.header2 = this.initvalue.header2.filter(x=>x.ignore!==true);
      let object_values2 = Object.groupBy(this.header2, item => { return item.value });
      let object_names2 = Object.groupBy(this.header2, item => { return item.text });
      this.header_values2 = Object.keys(object_values2);
      this.header_names2 = Object.keys(object_names2);
    }
    
    this.data_company = await this.getCompanyDataRequest(this.initvalue.report.companyid);
    this.logo = getLogo(this.initvalue.report.companyid);
  },
}

</script>

<style src="./../Print.scss" lang="scss"/>
